<cc-box>
  <div class="container-responsive" header box>
    {{'ACCOUNTS.INVOICE' | translate}}
  </div>

  <div class="container-responsive" content box>
    <mat-table
      matSort
      [dataSource]="dataSource"
      *ngIf="matDataSource.data.length > 0"
    >
      <ng-container matColumnDef="createdAt">
        <mat-header-cell *matHeaderCellDef mat-sort-header="createdAt"> {{ 'DATE' | translate }} </mat-header-cell>
        <mat-cell *matCellDef="let element">
          <a class="cell-inside text-info">{{ element.createdAt | amDateFormat:'L' }}</a>
        </mat-cell>
      </ng-container>

      <ng-container matColumnDef="amount">
        <mat-header-cell *matHeaderCellDef mat-sort-header="amount"> {{ 'PLANS.TOTAL' | translate }} </mat-header-cell>
        <mat-cell *matCellDef="let element">${{ element.amount.toFixed(2) }}</mat-cell>
      </ng-container>

      <ng-container matColumnDef="url">
        <mat-header-cell *matHeaderCellDef> {{ 'DOWNLOAD' | translate }} </mat-header-cell>
        <mat-cell *matCellDef="let element">
          <div class="download-icon" (click)="downloadClicked()">
            <a class="material-icons" [href]="element.url" target="_blank">vertical_align_bottom</a>
          </div>
        </mat-cell>
      </ng-container>

      <mat-header-row *matHeaderRowDef="displayedColumns; sticky: true"></mat-header-row>
      <mat-row *matRowDef="let row; columns: displayedColumns;"></mat-row>
    </mat-table>

    <cc-empty-table-message *ngIf="matDataSource.data.length === 0">
      <span translate>ACCOUNTS.NO_INVOICE</span>
    </cc-empty-table-message>
  </div>
</cc-box>
